export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 15.5a3 3 0 01-3 3V22a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 016 22v-3.5l-.154-.004A3 3 0 013 15.5v-12a3 3 0 013-3h12a3 3 0 013 3v12zm-2-12a1 1 0 00-1-1H6a1 1 0 00-1 1v12a1 1 0 00.897.995L6 16.5h12a1 1 0 001-1v-12z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};